exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span[data-v-0aa6ea20] {\n  text-transform: uppercase;\n  cursor: pointer;\n}\n", ""]);

// exports
